import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { IoCloseOutline } from "react-icons/io5";

import SelectMethod from "./components/SelectMethod";

import { animatePage } from "../../animateConstant";
import CloseComponent from "../../components/CloseComponent/CloseComponent";
import LoaderComponent from "../../components/Loading/LoaderComponent";
import MethodToggle from "./components/MethodToggle";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import LoadingBlock from "../../components/Loading/LoadingBlock";
import LoadingBank from "../../components/Loading/LoadingBank";
import LoadingLine from "../../components/Loading/LoadingLine";

const DepositStepOne = ({
  setChooseCurrency, //選擇幣別
  setDepositStep,
  depositStep, //目前步驟
  depositMethod, //提款方式
  cryptoPayments,
  isLoading,
  paymentData,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`deposit.${key}`);

  return (
    <motion.section
      initial={depositStep === 1 ? "hiddenRight" : "hiddenLeft"}
      animate="visible"
      exit={depositStep === 1 ? "hiddenRight" : "hiddenLeft"}
      variants={animatePage}
    >
      <CloseDetailPage title={i18n("deposit")} />

      <section>
        <p className="text-center text-transaction-text dark:text-base-light-white my-[20px]">
          {i18n("methodText")}
        </p>
        <section className="mb-[24px] p-2">
          <LoadingLine
            commonLoading={isLoading}
            className={`!w-[50px] !h-[10px] mb-[10px]`}
          >
            <p className="font-semibold text-lg text-transaction-text dark:text-base-light-white mb-[10px]">
              {i18n("recommend")}
            </p>
          </LoadingLine>
          <LoadingBank commonLoading={isLoading}>
            {depositMethod.map((item, index) => {
              const method = item; //提款方式
              const min = paymentData?.[item]?.min; //最小金額
              const max = paymentData?.[item]?.max; //最大金額

              return (
                <LoaderComponent commonLoading={isLoading}>
                  <SelectMethod
                    setChooseCurrency={setChooseCurrency}
                    setDepositStep={setDepositStep}
                    currency={`VND`}
                    isVip={paymentData?.[item]?.isVIP == 1}
                    method={method}
                    min={min}
                    max={max}
                  />
                </LoaderComponent>
              );
            })}
          </LoadingBank>
          <LoadingLine
            commonLoading={isLoading}
            className={`!w-[50px] !h-[10px] mb-[10px]`}
          >
            <p className="font-semibold text-lg text-transaction-text dark:text-base-light-white mb-[10px]">
              {i18n("crypto")}
            </p>
          </LoadingLine>
          <LoadingBank commonLoading={isLoading}>
            {Object.keys(cryptoPayments).map((item, index) => {
              const method = item; //提款方式

              return (
                <SelectMethod
                  setChooseCurrency={setChooseCurrency}
                  setDepositStep={setDepositStep}
                  currency={`VND`}
                  isCrypto={true}
                  method={method}
                />
              );
            })}
          </LoadingBank>
        </section>
        {/* <section className="mb-[24px]">
            <p className="font-extrabold text-xl text-main-color mb-[10px]">
              {i18n("other")}
            </p>
            <SelectMethod
              setChooseCurrency={setChooseCurrency}
              setDepositStep={setDepositStep}
              currency={`USDT`}
              method={`Deposit`}
            />
          </section> */}
      </section>
    </motion.section>
  );
};

export default DepositStepOne;
